import { Dialog } from "components/dialog";
import { Pencil, Trash } from "lucide-react";
import { useState } from "react";
import UserACLEdit from "../../user-edit";
import { CellContext } from "@tanstack/react-table";
import { ACLEntry } from "types";
import TooltipHorizon from "components/tooltip";

interface UserRowActionProps {
  info: CellContext<ACLEntry, string>;
  deletingRowId: string | null;
  handleDeleteRow: (id: string) => void;
}

export const UserRowAction: React.FC<UserRowActionProps> = (props) => {
  const { info, deletingRowId, handleDeleteRow } = props;
  const user = info.row.original;
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="flex items-center gap-3">
      <Dialog
        header={`Edit user's permissions`}
        setIsOpen={setIsOpen}
        isOpen={isOpen}
        children={
          <UserACLEdit permission={user.permissions} id={user.subject_id} />
        }
        trigger={
          <>
            <TooltipHorizon
              extra=""
              trigger={
                <button
                  className="rounded p-2 hover:bg-gray-100 dark:hover:bg-navy-700"
                  onClick={() => setIsOpen(true)}
                  disabled={deletingRowId?.trim().length > 0}
                >
                  <Pencil size={15} className="text-brand-500" />
                </button>
              }
              content={<span>Edit user</span>}
              placement="top"
            />
          </>
        }
      />
      <TooltipHorizon
        extra=""
        trigger={
          <button
            className="rounded p-2 hover:bg-gray-100 dark:hover:bg-navy-700"
            onClick={() => {
              handleDeleteRow(info.getValue());
            }}
            disabled={deletingRowId?.trim().length > 0}
          >
            <Trash size={15} className="text-red-500" />
          </button>
        }
        content={<span>Remove user</span>}
        placement="top"
      />
    </div>
  );
};
